/** Contenu statique de la landing page (textes, workflows, fonctionnalités). */
export const LANDING_STATIC_CONTENT = {
  hero: {
    badge: 'Plateforme de livraison N°1 en Afrique',
    title: 'Livraison',
    titleHighlight: 'Intelligente',
    titleSuffix: "pour l'Afrique",
    subtitle:
      'Connectez-vous avec des livreurs communautaires ou professionnels. Paiement Mobile Money, suivi en temps réel, disponible même hors ligne.',
  },
  statLabels: {
    completed_deliveries: 'Livraisons réalisées',
    coverage_areas: 'Zones couvertes',
    average_rating: 'Note moyenne',
    average_delivery_hours: 'Délai moyen',
  },
  features: [
    {
      icon: 'ri-wifi-off-line',
      color: 'green',
      title: 'Mode Hors Ligne',
      desc: "Continuez à utiliser l'app même sans internet.",
      highlight: 'Synchronisation automatique dès la reconnexion.',
    },
    {
      icon: 'ri-smartphone-line',
      color: 'orange',
      title: 'Mobile Money',
      desc: 'Paiements via Orange Money, MTN, Moov et solutions locales.',
      highlight: 'Zéro commission pour les clients.',
    },
    {
      icon: 'ri-global-line',
      color: 'blue',
      title: 'Multilingue',
      desc: 'Français, anglais, swahili, wolof, arabe et portugais.',
      highlight: "Adaptation culturelle de l'interface.",
    },
    {
      icon: 'ri-shield-keyhole-line',
      color: 'red',
      title: 'Sécurité Avancée',
      desc: 'Authentification OTP, chiffrement des données.',
      highlight: 'Traçabilité des transactions.',
    },
  ],
  trackingSteps: [
    { key: 'pending', label: 'Commande confirmée' },
    { key: 'in_progress', label: 'Colis pris en charge' },
    { key: 'delivering', label: 'En cours de livraison' },
    { key: 'delivered', label: 'Livré' },
  ],
} as const;

export const languages = [
  { code: 'fr', name: 'Français', flag: '🇫🇷', description: 'Langue principale' },
  { code: 'en', name: 'English', flag: '🇬🇧', description: 'International' },
  { code: 'sw', name: 'Kiswahili', flag: '🇰🇪', description: "Afrique de l'Est" },
  { code: 'wo', name: 'Wolof', flag: '🇸🇳', description: 'Sénégal' },
  { code: 'ar', name: 'العربية', flag: '🇲🇦', description: 'Afrique du Nord' },
  { code: 'pt', name: 'Português', flag: '🇦🇴', description: 'Afrique lusophone' },
];
